//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from '~/components/Shared/Button'
import ModalWithTitleBar from '~/components/Shared/ModalWithTitleBar'

export default {
  name: 'ConfirmRegisterUserWithEmailModal',
  components: { Button, ModalWithTitleBar },
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    toLabel: {
      type: String,
      default: 'Usuarios',
    },
  },
  data() {
    return {
      active: this.value,
    }
  },
  watch: {
    value() {
      this.active = this.value
    },
  },
  methods: {
    async finalize() {
      await this.$router.push('/invitaciones/empleados')
    },

    close() {
      this.active = !this.active
      this.$emit('close')
      this.$emit('input', this.active)
    },
  },
}
